<template>
    <div class="changeApply">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
            <div class="projectCorrelation">
                <el-form-item label="项目名称：" prop="name">
                    <el-input v-if="title === '修改报名'"
                        class="input-box"
                        v-model="form.name"
                        >
                    </el-input>
                    <el-input v-if="title === '报名详情'"
                        disabled
                        class="detail-input-box"
                        v-model="rowData.name">
                    </el-input>
                    <el-input v-if="title === '立即报名'"
                        class="detail-input-box"
                        v-model="form.name"
                        placeholder="请填写项目名称">
                    </el-input>
                </el-form-item>

                <el-form-item label="项目领域：" prop="projectregion">
                    <el-select v-if="title === '修改报名'"
                        class="input-box"
                        v-model="form.projectregion"
                        placeholder="请选择项目领域">
                        <el-option v-for="(item,index) in region"
                            :key="index"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                    <el-input v-if="title === '报名详情'"
                        disabled
                        class="detail-input-box"
                        v-model="rowData.projectRealm">
                    </el-input>
                    <el-select v-if="title === '立即报名'"
                        class="input-box"
                        v-model="form.projectregion"
                        placeholder="请选择项目领域">
                        <el-option v-for="(item,index) in region"
                            :key="index"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>

            <div class="projectCorrelation">
                <el-form-item label="联 系 人：" prop="people">
                    <el-input v-if="title === '修改报名'"
                        class="input-box"
                        v-model="form.people"
                        placeholder="请填写联系人">
                    </el-input>
                    <el-input v-if="title === '报名详情'"
                        disabled
                        class="detail-input-box"
                        v-model="rowData.contactPeople">
                    </el-input>
                    <el-input v-if="title === '立即报名'"
                        class="detail-input-box"
                        v-model="form.people"
                        placeholder="请填写联系人">
                    </el-input>
                </el-form-item>

                <el-form-item label="手 机 号：" prop="phone">
                    <el-input v-if="title === '修改报名'"
                        class="input-box"
                        v-model="form.phone"
                        placeholder="请填手机号">
                    </el-input>
                    <el-input v-if="title === '报名详情'"
                        disabled
                        class="detail-input-box"
                        v-model="rowData.phone">
                    </el-input>
                    <el-input v-if="title === '立即报名'"
                        class="detail-input-box"
                        v-model="form.phone"
                        placeholder="请填写手机号">
                    </el-input>
                </el-form-item>
            </div>

            <div class="projectCorrelation">
                <el-form-item label="邮 箱：" prop="email">
                    <el-input v-if="title === '修改报名'"
                        class="input-box"
                        v-model="form.email"
                        placeholder="请输入邮箱号">
                    </el-input>
                    <el-input v-if="title === '报名详情'"
                        disabled
                        class="detail-input-box"
                        v-model="rowData.email">
                    </el-input>
                     <el-input v-if="title === '立即报名'"
                        class="detail-input-box"
                        v-model="form.email"
                        placeholder="请输入邮箱号">
                    </el-input>
                </el-form-item>
            </div>

            <div class="projectCorrelation">
                <div>
                    <p class="upload-template-tit"><span style="color:red;">*</span>
                        参赛报名表：
                        <img v-if="PartyInTemplateForm.iconType === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="PartyInTemplateForm.iconType === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="PartyInTemplateForm.iconType === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                        <img v-if="PartyInTemplateForm.iconType === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                        <el-link v-if="title === '立即报名' || title === '修改报名'"
                            style="overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;white-space:nowrap;max-width:220px;height:24px;display:inline-block;"
                            :href="PartyInTemplateForm.userUploadUrl.substr(-3) === 'zip'? PartyInTemplateForm.userUploadUrl : ''"
                            target="_blank"
                            type="primary"
                            :title="getfileName(rowData.enrollInfo)"
                            @click="fileType(PartyInTemplateForm.userUploadUrl || rowData.enrollInfo) "
                            class="file-name">
                            <!-- {{getfileName(PartyInTemplateForm.userUploadName)}} -->
                            {{getfileName(PartyInTemplateForm.userUploadUrl || rowData.enrollInfo)}}
                        </el-link>
                    </p>
                    <div class="upload-template">
                        <upload-file-btn :acceptFiletype="'.doc,.pdf,.docx'" v-if="title === '修改报名' || title === '立即报名'"
                            :fileID="PartyInTemplateForm.id"
                            @getFileNames="applyFormName"
                            @getFileUrls="applyFormUrl">
                        </upload-file-btn>
                        <p class="download-tit" v-if="title === '修改报名' || title === '立即报名'">请下载模板，填写完后上传</p>
                        <el-link v-if="title === '修改报名'"
                            :href="rowData.competition.enrollTemplate.substr(-3) === 'zip'? rowData.credencialInfo : ''"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileType(rowData.competition.enrollTemplate)">
                            <span>
                                <img v-if="rowData.competition.enrollTemplate.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.competition.enrollTemplate.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.competition.enrollTemplate.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.competition.enrollTemplate.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>{{PartyInTemplateForm.name}}↓</span>
                        </el-link>
                        <el-link v-if="title === '报名详情'"
                            :href="rowData.enrollInfo.substr(-3) === 'zip'? rowData.credencialInfo : ''"
                            :disabled="rowData.enrollInfo===''"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileType(rowData.enrollInfo)">
                            <span>
                                <img v-if="rowData.enrollInfo.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.enrollInfo.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.enrollInfo.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.enrollInfo.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>参赛报名表↓</span>
                        </el-link>
                        <el-link v-if="title === '立即报名'"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileRead(templates.enrollTemplate)">
                            <span><img :src="PartyInTemplateForm.Wicon" alt=""></span>
                            <span>{{PartyInTemplateForm.name}}↓</span>
                        </el-link>
                    </div>
                </div>

                <div>
                    <p class="upload-template-tit"><span style="color:red;">*</span> 参赛承诺书：
                        <img v-if="PartyInUndertaking.iconType === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="PartyInUndertaking.iconType === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="PartyInUndertaking.iconType === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                        <img v-if="PartyInUndertaking.iconType === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                        <el-link v-if="title === '立即报名' || title === '修改报名'"
                            style="overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;white-space:nowrap;max-width:220px;height:24px;display:inline-block;"
                            :href="PartyInUndertaking.userUploadUrl.substr(-3) === 'zip'? PartyInUndertaking.userUploadUrl : ''"
                            target="_blank"
                            type="primary"
                            :title="getfileName(rowData.promiseInfo)"
                            @click="fileType(PartyInUndertaking.userUploadUrl || rowData.promiseInfo) "
                            class="file-name">
                            <!-- {{getfileName(PartyInUndertaking.userUploadName)}} -->
                            {{getfileName(PartyInUndertaking.userUploadUrl || rowData.promiseInfo)}}
                        </el-link>
                    </p>
                    <div class="upload-template">
                        <upload-file-btn :acceptFiletype="'.doc,.pdf,.docx'" v-if="title === '修改报名' || title === '立即报名'"
                            :fileID="PartyInUndertaking.id"
                            @getFileNames="commitmentName"
                            @getFileUrls="commitmentUrl">
                        </upload-file-btn>
                        <p class="download-tit" v-if="title === '修改报名' || title === '立即报名'">请下载模板，填写完后上传</p>
                        <el-link v-if="title === '修改报名'"
                            :href="rowData.competition.promiseTemplate.substr(-3) === 'zip'? rowData.credencialInfo : ''"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileType(rowData.competition.promiseTemplate)">
                            <span>
                                <img v-if="rowData.competition.promiseTemplate.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.competition.promiseTemplate.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.competition.promiseTemplate.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.competition.promiseTemplate.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>{{PartyInUndertaking.name}}↓</span>
                        </el-link>
                        <el-link v-if="title === '报名详情'"
                            :href="rowData.promiseInfo.substr(-3) === 'zip'? rowData.promiseInfo : ''"
                            :disabled="rowData.promiseInfo===''"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileType(rowData.promiseInfo)">
                            <span>
                                <img v-if="rowData.promiseInfo.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.promiseInfo.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.promiseInfo.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.promiseInfo.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>参赛承诺书↓</span>
                        </el-link>
                        <el-link v-if="title === '立即报名'"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileRead(templates.promiseTemplate)">
                            <span><img :src="PartyInTemplateForm.Wicon" alt=""></span>
                            <span>{{PartyInUndertaking.name}}↓</span>
                        </el-link>
                    </div>
                </div>
            </div>

            <div class="projectCorrelation">
                <div>
                    <p class="upload-template-tit"><span style="color:red;">*</span> 留学人员证明学历：
                        <img v-if="abroadCredential.iconType === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="abroadCredential.iconType === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="abroadCredential.iconType === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                        <img v-if="abroadCredential.iconType === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                        <el-link v-if="title === '立即报名' || title === '修改报名'"
                             style="overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;white-space:nowrap;max-width:210px;height:24px;display:inline-block;"
                            :href="abroadCredential.userUploadUrl.substr(-3) === 'zip'? abroadCredential.userUploadUrl : ''"
                            target="_blank"
                            type="primary"
                            :title="getfileName(rowData.credencialInfo)"
                            @click="fileType(abroadCredential.userUploadUrl || rowData.credencialInfo) "
                            class="file-name">
                            {{getfileName(abroadCredential.userUploadUrl || rowData.credencialInfo)}}
                        </el-link>
                    </p>
                    <div class="upload-template">
                        <upload-file-btn :acceptFiletype="'.doc,.pdf,.docx'" v-if="title === '修改报名' || title === '立即报名'"
                            :fileID="abroadCredential.id"
                            @getFileNames="abroadProveName"
                            @getFileUrls="abroadProveUrl">
                        </upload-file-btn>
                        <p class="download-tit" v-if="title === '修改报名' || title === '立即报名'">请下载模板，填写完后上传</p>
                        <el-link v-if="title === '修改报名'"
                            :href="rowData.competition.credentialTemplate.substr(-3) === 'zip'? rowData.credencialInfo : ''"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileType(rowData.competition.credentialTemplate)">
                            <span>
                                <img v-if="rowData.competition.credentialTemplate.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.competition.credentialTemplate.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.competition.credentialTemplate.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.competition.credentialTemplate.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>{{abroadCredential.name}}↓</span>
                        </el-link>
                        <el-link v-if="title === '报名详情'"
                            :href="rowData.credencialInfo.substr(-3) === 'zip'? rowData.credencialInfo : ''"
                            :disabled="rowData.credencialInfo===''"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileType(rowData.credencialInfo)">
                            <span>
                                <img v-if="rowData.credencialInfo.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.credencialInfo.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.credencialInfo.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.credencialInfo.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>学历证明↓</span>
                        </el-link>
                        <el-link v-if="title === '立即报名'"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileRead(templates.credentialTemplate)">
                            <span><img :src="PartyInTemplateForm.Wicon" alt=""></span>
                            <span>{{abroadCredential.name}}↓</span>
                        </el-link>
                    </div>
                </div>

                <div>
                    <p class="upload-template-tit"> <span style="color:red;">*</span> 宣传展示照片：
                        <img v-if="publicityPic.iconType === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                        <el-link style="color:#409EFF" :title="getfileName(publicityPic.userUploadName)"
                          :href="publicityPic.userUploadUrl || rowData.promotionPicture">
                            {{getfileName(publicityPic.userUploadUrl || rowData.promotionPicture)}}
                        </el-link>
                    </p>
                    <div class="upload-template">
                        <upload-file-btn :acceptFiletype="'.zip'" v-if="title === '修改报名' || title === '立即报名'"
                            :fileID="publicityPic.id"
                            @getFileNames="publicityPicName"
                            @getFileUrls="publicityPicUrl"
                            >
                        </upload-file-btn>
                        <p class="download-tit" v-if="title === '修改报名' || title === '立即报名'">
                            项目产品、创业团队或企业展示（公司环境、LOGO等）照片，建议上传多张，打包zip上传
                        </p>
                        <el-link v-if="title === '报名详情'"
                            :href="rowData.promotionPicture.substr(-3) === 'zip'? rowData.promotionPicture : ''"
                            :disabled="rowData.promotionPicture===''"
                            @click="fileType(rowData.promotionPicture)"
                            target="_blank"
                            type="primary"
                            class="download-file">
                            <span>
                                <img v-if="rowData.promotionPicture.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.promotionPicture.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.promotionPicture.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.promotionPicture.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>宣传展示照片↓</span>
                        </el-link>
                    </div>
                </div>
            </div>

            <div class="projectCorrelation">
                <div>
                    <p class="upload-template-tit">知识产权证明：
                        <img v-if="intellectualProperty.iconType === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="intellectualProperty.iconType === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="intellectualProperty.iconType === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                        <img v-if="intellectualProperty.iconType === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                        <el-link v-if="title === '立即报名' || title === '修改报名'"
                             style="overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;white-space:nowrap;max-width:220px;height:24px;display:inline-block;"
                            :href="intellectualProperty.userUploadUrl.substr(-3) === 'zip'? intellectualProperty.userUploadUrl : ''"
                            target="_blank"
                            type="primary"
                            :title="getfileName(intellectualProperty.userUploadName)"
                            @click="fileType(intellectualProperty.userUploadUrl || rowData.patentInfo) "
                            class="file-name">
                            {{getfileName(intellectualProperty.userUploadUrl || rowData.patentInfo)}}
                        </el-link>
                    </p>
                    <div class="upload-template">
                        <upload-file-btn  v-if="title === '修改报名' || title === '立即报名'"
                            :fileID="intellectualProperty.id"
                            @getFileNames="knowledgeName"
                            @getFileUrls="knowledgeUrl">
                        </upload-file-btn>
                        <p class="download-tit"  v-if="title === '修改报名' || title === '立即报名'">请下载模板，填写完后上传</p>
                        <el-link v-if="title === '修改报名'"
                            :href="rowData.competition.patentTemplate.substr(-3) === 'zip'? rowData.credencialInfo : ''"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileType(rowData.competition.patentTemplate)">
                            <span>
                                <img v-if="rowData.competition.patentTemplate.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.competition.patentTemplate.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.competition.patentTemplate.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.competition.patentTemplate.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>{{intellectualProperty.name}}↓</span>
                        </el-link>
                        <el-link v-if="title === '报名详情'"
                            :href="rowData.patentInfo.substr(-3) === 'zip'? rowData.patentInfo : ''"
                            :disabled="rowData.patentInfo==='' "
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileType(rowData.patentInfo)">
                            <span>
                                <img v-if="rowData.patentInfo.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.patentInfo.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.patentInfo.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.patentInfo.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>知识产权证明↓</span>
                        </el-link>
                        <el-link v-if="title === '立即报名'"
                            target="_blank"
                            type="primary"
                            class="download-file"
                            @click="fileRead(templates.patentTemplate)">
                            <span><img :src="PartyInTemplateForm.Wicon" alt=""></span>
                            <span>{{intellectualProperty.name}}↓</span>
                        </el-link>
                    </div>
                </div>

                <div>
                    <p class="upload-template-tit"><span style="color:red;">*</span>项目BP：
                        <img v-if="projectBP.iconType === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="projectBP.iconType === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                        <img v-if="projectBP.iconType === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                        <img v-if="projectBP.iconType === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                        <el-link v-if="title === '立即报名' || title === '修改报名'"
                             style="overflow: hidden; text-overflow: ellipsis; -o-text-overflow: ellipsis;white-space:nowrap;max-width:220px;height:24px;display:inline-block;"
                            :href="projectBP.userUploadUrl.substr(-3) === 'zip'? projectBP.userUploadUrl : ''"
                            target="_blank"
                            type="primary"
                            :title="getfileName(projectBP.userUploadName)"
                            @click="fileType(projectBP.userUploadUrl || rowData.bussinessPlan) "
                            class="file-name">
                            {{getfileName(projectBP.userUploadUrl || rowData.bussinessPlan)}}
                        </el-link>
                    </p>
                    <div class="upload-template">
                        <upload-file-btn :acceptFiletype="true"  v-if="title === '修改报名' || title === '立即报名'"
                            :fileID="projectBP.id"
                            @getFileNames="projectBPName"
                            @getFileUrls="projectBPUrl">
                        </upload-file-btn>
                        <p class="download-tit"  v-if="title === '修改报名' || title === '立即报名'">
                            <!-- .pdf或.doc或zip -->
                            .pdf或.ppt
                        </p>
                        <el-link v-if="title === '报名详情'"
                            :href="rowData.bussinessPlan.substr(-3) === 'zip'? rowData.bussinessPlan : ''"
                            :disabled="rowData.bussinessPlan==='' "
                            target="_blank"
                            type="primary"
                            @click="fileType(rowData.bussinessPlan) "
                            class="download-file">
                            <span>
                                <img v-if="rowData.bussinessPlan.substr(-3) === 'doc'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.bussinessPlan.substr(-3) === 'ocx'" :src="PartyInTemplateForm.Wicon" alt="">
                                <img v-if="rowData.bussinessPlan.substr(-3) === 'pdf'" :src="PartyInTemplateForm.Picon" alt="">
                                <img v-if="rowData.bussinessPlan.substr(-3) === 'zip'" :src="PartyInTemplateForm.Zicon" alt="">
                            </span>
                            <span>项目BP↓</span>
                        </el-link>
                    </div>
                </div>
            </div>

            <div class="btn-style" v-if=" title === '修改报名'">
                <el-button class="confirmBtn btn" @click="commitChangeForm">确认无误提交</el-button>
                <el-button class="cancleBtn btn" @click="cancelAmend">取消</el-button>
            </div>

            <div class="btn-style" v-if=" title === '立即报名'">
                <el-button class="confirmBtn btn" @click="commitForm">确认无误提交</el-button>
                <el-button class="cancleBtn btn" @click="cancelAmend">取消</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import UploadFileBtn from './uploadFileBtn.vue'

export default {
  name: 'changeApply',
  props: {
    dialogCauseVisible: Boolean,
    title: String,
    rowData: Object
  },
  components: {
    UploadFileBtn
  },
  data () {
    return {
      form: {
        name: '', // 项目名称
        projectregion: '', // 项目领域
        people: '', // 联系人
        phone: '', // 手机号
        email: ''// 邮箱
      },
      region: ['全部', '电子信息', '生物与新医药', '新材料', '高技术服务', '新能源与节能', '资源与环境', '先进制造与自动化', '现代服务业', '其他行业领域'], // 项目领域
      rules: {
        name: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 1, max: 30, message: '项目名称不能超过30个字符', trigger: 'blur' }
        ],
        projectregion: [
          { required: true, message: '请选项目领域', trigger: 'change' }
        ],
        people: [
          { required: true, message: '请填写联系人', trigger: 'blur' },
          { min: 1, max: 10, message: '联系人不能超过10个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ]
      },
      templates: {}, // 报名模板列表
      currentPage: 1,
      // 参赛模板
      PartyInTemplateForm: {
        Wicon: require('@/assets/user/word-icon.png'),
        Picon: require('@/assets/user/pdf-icon.png'),
        Zicon: require('@/assets/user/zip-icon.png'),
        name: '参赛报名表模板',
        id: 'applyForm',
        userUploadName: '',
        userUploadUrl: '',
        iconType: ''
      },

      // 参赛承诺书
      PartyInUndertaking: {
        name: '参赛承诺书模板',
        id: 'commitment',
        userUploadName: '',
        userUploadUrl: '',
        iconType: ''
      },

      // 留学人员学历证明
      abroadCredential: {
        name: '学历证明模板',
        id: 'abroadProve',
        userUploadName: '',
        userUploadUrl: '',
        iconType: ''
      },

      // 知识产权证明
      intellectualProperty: {
        name: '知识产权证明模板',
        id: 'knowledge',
        userUploadName: '',
        userUploadUrl: '',
        iconType: ''
      },

      // 宣传展示照片
      publicityPic: {
        id: 'publicity',
        userUploadName: '',
        userUploadUrl: '',
        iconType: ''
      },

      // 项目BP
      projectBP: {
        id: 'project',
        userUploadName: '',
        userUploadUrl: '',
        iconType: ''
      }

    }
  },
  computed: {

  },
  created () {
    this.getTemplates()
    this.getChangeApplyData()
  },
  mounted () {
    // 参赛报名表
    console.log('changeApplyMouted')
    console.log(this.rowData)
    console.log('changeApplyMouted')

    // this.PartyInTemplateForm.userUploadUrl = this.rowData.competition.credentialTemplate
    // this.PartyInTemplateForm.userUploadName = this.rowData.competition.credentialTemplate
    // // 参赛承诺书
    // this.PartyInUndertaking.userUploadUrl = this.rowData.competition.promiseTemplate
    // this.PartyInUndertaking.userUploadName = this.rowData.competition.promiseTemplate
    // // 留学人员证明学历
    // this.abroadCredential.userUploadUrl = this.rowData.competition.credentialTemplate
    // this.abroadCredential.userUploadName = this.rowData.competition.credentialTemplate
    // // 知识产权证明
    // this.intellectualProperty.userUploadUrl = this.rowData.competition.patentTemplate
    // this.intellectualProperty.userUploadName = this.rowData.competition.patentTemplate
    // // 宣传展示照片
    // this.publicityPic.userUploadUrl = this.rowData.promotionPicture
    // this.publicityPic.userUploadName = this.rowData.promotionPicture
    // // 项目BP
    // this.projectBP.userUploadUrl = this.rowData.bussinessPlan
    // this.projectBP.userUploadName = this.rowData.bussinessPlan
  },
  methods: {
    // world 文件预览及下载
    fileRead (file) {
      if (file === null) { return }
      window.open('https://view.officeapps.live.com/op/view.aspx?src=' + file)
    },
    // pdf 文件预览及下载
    pdfFileRead (file) {
      if (file === null) { return }
      window.open(file)
    },
    // 报名记录报名详情查看文件类型判断
    fileType (file) {
      const type = file.substr(-3)
      if (type === 'pdf') {
        this.pdfFileRead(file)
      } else if (type === 'doc' || type === 'ocx') {
        this.fileRead(file)
      } else if (type === 'zip') {
        window.location.href = file
      }else{
        window.location.href = file
      }
    },
    // 截取链接中的name
    getfileName (str) {
      if (str && str.indexOf('_')) {
        return str.split('_')[str.split('_').length - 1]
      }
      // return str.split('/')[str.split('/').length - 1]
    },

    // 修改报名提取数据
    getChangeApplyData () {
      if (this.rowData && this.title === '立即报名') { return false }
      // if (!this.rowData ) { return false }
      this.form.name = this.rowData.name
      this.form.projectregion = this.rowData.projectRealm
      this.form.people = this.rowData.contactPeople
      this.form.phone = this.rowData.phone
      this.form.email = this.rowData.email
      console.log(this.rowData)
    },

    // 取消修改
    cancelAmend () {
      this.$emit('dialogCauseVisible')
    },

    // 确定提交
    commitApplay () {
      this.$emit('dialogCommitApplay')
    },

    // 获取报名模板
    getTemplates () {
      this.templates = JSON.parse(sessionStorage.getItem('activityDetail'))
    },

    // 获取项目BP文件名
    projectBPName (name) {
      this.projectBP.userUploadName = name
      this.projectBP.iconType = this.projectBP.userUploadName.substr(-3)
    },
    // 获取项目BP文件地址
    projectBPUrl (url) {
      this.projectBP.userUploadUrl = url
    },

    // 获取知识产权文件名
    knowledgeName (name) {
      this.intellectualProperty.userUploadName = name
      this.intellectualProperty.iconType = this.intellectualProperty.userUploadName.substr(-3)
    },
    // 获取知识产权文件地址
    knowledgeUrl (url) {
      this.intellectualProperty.userUploadUrl = url
    },

    // 获取宣传展示照片文件名
    publicityPicName (name) {
      console.log(name)
      // if(name.lastIndexof('.')==zip){
      //   console.log()
      // }
      this.publicityPic.userUploadName = name
      this.publicityPic.iconType = this.publicityPic.userUploadName.substr(-3)
    },
    // 获取宣传展示照片文件地址
    publicityPicUrl (url) {
      this.publicityPic.userUploadUrl = url
    },

    // 获取留学证明文件名
    abroadProveName (name) {
      this.abroadCredential.userUploadName = name
      this.abroadCredential.iconType = this.abroadCredential.userUploadName.substr(-3)
    },
    // 获取留学证明文件地址
    abroadProveUrl (url) {
      this.abroadCredential.userUploadUrl = url
    },

    // 获取参赛承诺书文件名
    commitmentName (name) {
      this.PartyInUndertaking.userUploadName = name
      this.PartyInUndertaking.iconType = this.PartyInUndertaking.userUploadName.substr(-3)
    },
    // 获取参赛承诺书文件地址
    commitmentUrl (url) {
      this.PartyInUndertaking.userUploadUrl = url
    },

    // 获取参赛报名表文件名
    applyFormName (name) {
      this.PartyInTemplateForm.userUploadName = name
      this.PartyInTemplateForm.iconType = this.PartyInTemplateForm.userUploadName.substr(-3)
    },
    // 获取参赛报名表文件地址
    applyFormUrl (url) {
      this.PartyInTemplateForm.userUploadUrl = url
    },

    // 提交报名
    async commitForm () {
      if (this.form.name === '') {
        this.$message.error('请输入项目名称')
        return
      }
      if (this.form.projectregion === '') {
        this.$message.error('请选择项目领域')
        return
      }
      if (this.form.people === '') {
        this.$message.error('请输入联系人')
        return
      }
      if (this.form.phone === '') {
        this.$message.error('请输入手机号码')
        return
      }
      if (this.form.email === '') {
        this.$message.error('请输入邮箱')
        return
      }
      if (this.PartyInTemplateForm.userUploadUrl === '') {
        this.$message.error('请上传参赛报名表')
        return
      }
      if (this.PartyInUndertaking.userUploadUrl === '') {
        this.$message.error('请上传参赛承诺书')
        return
      }
      if (this.abroadCredential.userUploadUrl === '') {
        this.$message.error('请上传留学人员证明学历')
        return
      }
      if (this.publicityPic.userUploadUrl === '') {
        this.$message.error('请上传宣传展示照片')
        return
      }
      if (this.projectBP.userUploadUrl === '') {
        this.$message.error('请上传项目BP')
        return
      }
      try {
        const res = await this.$post(this.$url.activity.submitApplyForm, {
          competitionId: JSON.parse(sessionStorage.getItem('activityDetail')).id,
          name: this.form.name,
          projectRealm: this.form.projectregion,
          contactPeople: this.form.people,
          phone: this.form.phone,
          email: this.form.email,
          enrollInfo: this.PartyInTemplateForm.userUploadUrl,
          promiseInfo: this.PartyInUndertaking.userUploadUrl,
          credencialInfo: this.abroadCredential.userUploadUrl,
          promotionPicture: this.publicityPic.userUploadUrl,
          patentInfo: this.intellectualProperty.userUploadUrl,
          bussinessPlan: this.projectBP.userUploadUrl
        })

        const { code, msg } = res.data
        if (code === 200) {
          this.$emit('dialogCommitApplay')
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 修改报名表
    async commitChangeForm () {
      try {
        const res = await this.$post(this.$url.activity.submitApplyForm, {
          competitionId: this.rowData.competitionId,
          name: this.form.name,
          projectRealm: this.form.projectregion,
          contactPeople: this.form.people,
          phone: this.form.phone,
          email: this.form.email,
          enrollInfo: this.PartyInTemplateForm.userUploadUrl || this.rowData.enrollInfo,
          promiseInfo: this.PartyInUndertaking.userUploadUrl || this.rowData.promiseInfo,
          credencialInfo: this.abroadCredential.userUploadUrl || this.rowData.credencialInfo,
          promotionPicture: this.publicityPic.userUploadUrl || this.rowData.promotionPicture,
          patentInfo: this.intellectualProperty.userUploadUrl || this.rowData.patentInfo,
          bussinessPlan: this.projectBP.userUploadUrl || this.rowData.bussinessPlan
        })

        const { code, msg } = res.data
        if (code === 200) {
          this.$emit('dialogCommitApplay')
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped lang="less">
.changeApply{
    // width: 905px;
    height: 800px;
    display: flex;
    justify-content: center;
    // align-items: center;
    box-sizing: border-box;
    // padding: 0 110px;
    font-size: 14px;
}
.projectCorrelation{
    display: flex;
    justify-content: left;
}
.input-box{
    width: 230px;
}
.detail-input-box{
    width: 230px;

    /deep/.el-input__inner{
        color: #999;
    }
}
.upload-template-tit{
    line-height: 30px;
    img{
        vertical-align: middle;
    }
    .file-name{
        font-size: 12px;
        margin-left: 8px;
        cursor: pointer;
    }
}
.upload-template{
    width: 334px;
    height: 129px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    margin-right: 15px;
    margin-bottom: 20px;
    padding: 0 25px 0;
    border: 1px solid  #EBEBEB;
    .download-tit{
        font-size: 12px;
        color: #999999;
        box-sizing: border-box;
        margin: 13px 0 10px;
        text-align: center;
    }
    .download-file{
        img{
            vertical-align:bottom;
            margin-right: 5px;
        }
    }
}
.upload-template:nth-of-type(2n){
    margin-right: 0;
}

.btn-style{
    width: 685px;
    height: 34px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    margin-top: 28px;
}
.btn{
    width: 123px;
    height: 34px;
    line-height: 10px;
    text-align: center;
    box-shadow: 0px 2px 6px 0px rgba(96, 122, 244, 0.54);
    border-radius: 2px;
    color: #fff;
}
.confirmBtn{
    background-color: #3056D9;
    border: 1px solid #3056D9;
}
.cancleBtn{
    background-color: #494D60;
    border: 1px solid #494D60;
}

</style>
